import { Plan } from "@memaro/api";

export const PROFILE_PICTURE_PLACEHOLDER = 'placeholder.png';

export type PlanDefinition = {
    plan: Plan;
    title: string;
    price: number;
    color: string;
    features: string[];
}

export const plans: PlanDefinition[] = [
    {
        plan: Plan.Bronze,
        title: 'BRONS',
        price: 20,
        color: '#37474F',
        features: ['2GB opslag', 'Teksten', 'Foto\'s'],
    },
    {
        plan: Plan.Silver,
        title: 'ZILVER',
        price: 30,
        color: '#B0BEC5',
        features: ['Alles in brons', '3 GB opslag extra; Totaal 5GB', 'Video\'s', 'Audio fragmenten'],
    },
];
